import styled from "styled-components";

export const Container = styled.div`

 display: flex;
 align-items: center;
 flex-direction: column;
 justify-content: flex-start;

  background-color: #FFFFFF;
`

export const Wrapper = styled.div`
  width: 100%;
  padding: 16px;
  max-width: 1150px;

  gap: 24px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 880px) {
    gap: 16px;
  }

  @media (max-width: 760px) {
    margin: 0;
    padding: 16px;
  }
`

export const Searchs = styled.div`
    display: flex;
    flex: 1;
    gap: 1rem;

    @media (max-width: 880px) {
        flex-direction: column;
    }
`

export const ContainerSearchs = styled.div`
  padding: 1rem;
  padding-bottom: 2rem;
  
  margin: 1rem 2rem;
  border-radius: 1rem;
  background-color: #F8F8F9;

    @media (max-width: 760px) {
        padding: 1rem;
        margin: 1rem;
    }
`

export const SearchBody = styled.div`
  width: 100%;
  height: auto;

  gap: 24px;
  display: flex;

  @media (max-width: 880px) {
    flex-direction: column;
  }

  @media (max-width: 760px) {
        gap: 1rem;
    }
`

export const ContainerCards = styled.div`
  display: flex;
  padding-inline: 2rem;
`

export const FormContainerCompendioGratis = styled.div`


padding: 50px 0 0 0;
background: #f8f8f9;

div {
    form {
        margin: auto;
        margin-top: -100px;
        background-color: #FFF;
        height: ${props => (props.isOpen ? "400px" : "100px")};
        border-radius: 10px;
        box-shadow: 0 0 20px 0 rgba(29, 33, 41, 0.05);
        width: 900px;
        margin-left: ${props => (props.isMobile ? "-85px" : "")};
        display: flex;
        flex-direction: row;
        justify-content: ${props => (props.isMobile ? "space-between" : "center")};

        .css-26l3qy-menu{
            button{
                width: 50px;
                height: 20px;
                border-radius: 10px;
                border: solid 1.3px #00b43f;
                font-family: Lato;
                font-size: 8px;
                font-weight: 900;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #00b43f;
                transition: all 0.3s;
                position: absolute;
                right: 15px;
                margin-top: -15px;
    
                &:hover{
                    background-color: #00b43f;
                    color: #FFF;
                }
            }
        }

        .botaolabel {
            width: 100%;
            max-width: 400px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: row-reverse;

            label {
                margin-top: 25px;
            }
        }

        

        .css-1uccc91-singleValue{
            a{
                display: none;
            }
            label{
                display: none;
            }
            p{
                margin-top: 15px;
            }
        }
        
        .css-z2bfxu-control{
            a{
                display: none;
            }
            label{
                display: none;
            }
            p{
                margin-top: 15px;
            }
        }

        .click{
            margin-left: 10px;
            margin-right: 10px;
            margin-top: 10px;
            height: 50px;
            border-radius: 25px;
            
            .sc-TOsTZ {
                margin: 0px;
                padding: 0px;
                margin-top: -15px;
                width: ${props => (props.isMobile ? "50px" : "")};

            }

        }
    }

    .boxClear{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        label{
            color: #589BFF;
            text-align: right;
            margin-right: 120px;

            &:hover{
                cursor: pointer;
            }
        }
    }
    .info{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        margin-top: 7%;
        z-index: -1;
        
        .text{
            width: 338px;
            height: 68px;
            margin: auto;
            font-family: Lato;
            font-size: 28px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            text-align: center;
            color: #bac1cf;
            margin-bottom: 50px;
            left: 50%;
        }

        .image-search{
        }
    }
    @media only screen and (max-width: 768px) {
        .info{
            margin-top: 90px !important;
        }
    }
}

@media only screen and (max-width: 1105px) {
    div{
        form {
            
        }
    }
}

@media only screen and (max-width: 768px) {
    div {
        form {
            display: flex;
            flex-direction: column;
            margin: auto;
            margin-top: -100px;
            background-color: #FFF;
            padding-bottom: 45px;
            border-radius: 10px;
            box-shadow: 0 0 20px 0 rgba(29, 33, 41, 0.05);
            width: 50%;
            height: auto;

            .click{
                margin-left: 10px;
                margin-right: 10px;
                margin-top: 8px;
                margin-bottom: 20px;
                height: 50px;
                border-radius: 25px;

                .css-26l3qy-menu{
                    width: 270px;
                    border-color: rgba(255, 255, 255, 0);
                    border-style: solid;
                    border-width: 1px;
                    box-shadow: 0 0 20px 0 rgba(29,33,41,0.05);
                    position: absolute;
                    left: 35px;
                    padding-top: 0px;
                    margin-top: -15px;
                    z-index: 3;
                    border-bottom-right-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                
                .sc-TOsTZ {
                    margin: 0px;
                    padding: 0px;
                    margin-top: -15px;
                    margin-left: 10px;
                    z-index: 3;
                }
            }
        }

        .info{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin-top: 20px;
            z-index: -1;
            
            .text{
                width: 338px;
                height: 68px;
                margin: auto;
                font-family: Lato;
                font-size: 20px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #bac1cf;
                margin-bottom: 50px;
                left: 50%;
            }

            .image-search{
            }
        }
    }

    
}

@media only screen and (max-width: 766px) {
    div{
        form {
            width: 60%;
        }
    }

}

@media only screen and (max-width: 640px) {
 
    div {
        form {
            display: flex;
            flex-direction: column;
            margin: auto;
            margin-top: -100px;
            background-color: #FFF;
            padding-bottom: 45px;
            border-radius: 10px;
            box-shadow: 0 0 20px 0 rgba(29, 33, 41, 0.05);
            width: 90%;
            height: 300px;

            #cultura{
                &:focus{
                    z-index: 2;
                }
            }

            .click{
                margin-left: 10px;
                margin-right: 10px;
                margin-top: 8px;
                height: 50px;
                border-radius: 25px;

                .css-26l3qy-menu{
                    width: 270px;
                    background-color: #f3f3f5;
                    border-color: rgba(255, 255, 255, 0);
                    border-style: solid;
                    border-width: 1px;
                    box-shadow: 0 0 20px 0 rgba(29,33,41,0.05);
                    position: absolute;
                    padding-top: 0px;
                    margin-top: -15px;
                    margin-left: 30px;
                    z-index: 3;
                    border-bottom-right-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                
                .sc-TOsTZ {
                    margin: 0px;
                    padding: 0px;
                    margin-top: -15px;
                    margin-left: 10px;
                    z-index: 3;
                }
            }
        }

        .info{
            z-index: -1;
            
            .text{
                width: 338px;
                height: 68px;
                margin: auto;
                font-family: Lato;
                font-size: 18px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #bac1cf;
                margin-bottom: 50px;
                left: 50%;
            }

            .image-search{
            }
        }
    }

}


@media only screen and (max-width: 550px) {
    div {
        form {
            display: flex;
            flex-direction: column;
            margin: auto;
            margin-top: -100px;
            background-color: #FFF;
            padding-bottom: 45px;
            border-radius: 10px;
            box-shadow: 0 0 20px 0 rgba(29, 33, 41, 0.05);
            width: 90%;
            height: 300px;

            .click{
                margin-left: 10px;
                margin-right: 10px;
                margin-top: 8px;
                height: 50px;
                border-radius: 25px;

                .css-26l3qy-menu{
                    width: 270px;
                    background-color: #f3f3f5;
                    border-color: rgba(255, 255, 255, 0);
                    border-style: solid;
                    border-width: 1px;
                    box-shadow: 0 0 20px 0 rgba(29,33,41,0.05);
                    position: absolute;
                    padding-top: 0px;
                    margin-top: -15px;
                    margin-left: 30px;
                    z-index: 3;
                    border-bottom-right-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                
                .sc-TOsTZ {
                    margin: 0px;
                    padding: 0px;
                    margin-top: -15px;
                    margin-left: 10px;
                    z-index: 3;
                }
            }
        }

        .info{
            z-index: -1;
            
            .text{
                width: 338px;
                height: 68px;
                margin: auto;
                font-family: Lato;
                font-size: 18px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #bac1cf;
                margin-bottom: 50px;
                left: 50%;
            }

            .image-search{
            }
        }
    }

}

@media only screen and (max-width: 411px) {
    div {
        form {
            display: flex;
            flex-direction: column;
            margin: auto;
            margin-top: -100px;
            background-color: #FFF;
            padding-bottom: 45px;
            border-radius: 10px;
            box-shadow: 0 0 20px 0 rgba(29, 33, 41, 0.05);
            width: 90%;
            height: 300px;

            .click{
                margin-left: 10px;
                margin-right: 10px;
                margin-top: 8px;
                height: 50px;
                border-radius: 25px;

                .css-26l3qy-menu{
                    width: 270px;
                    background-color: #f3f3f5;
                    border-color: rgba(255, 255, 255, 0);
                    border-style: solid;
                    border-width: 1px;
                    box-shadow: 0 0 20px 0 rgba(29,33,41,0.05);
                    position: absolute;
                    padding-top: 0px;
                    margin-top: -15px;
                    margin-left: -10px;
                    z-index: 3;
                    border-bottom-right-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                
                .sc-TOsTZ {
                    margin: 0px;
                    padding: 0px;
                    margin-top: -15px;
                    margin-left: 10px;
                    z-index: 3;
                }
            }
        }

        .info{
            z-index: -1;
            
            .text{
                width: 338px;
                height: 68px;
                margin: auto;
                font-family: Lato;
                font-size: 18px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #bac1cf;
                margin-bottom: 50px;
                left: 50%;
            }

            .image-search{
            }
        }
    }

}
@media only screen and (max-width: 375px) {
    div {
        form {
            display: flex;
            flex-direction: column;
            margin: auto;
            margin-top: -100px;
            background-color: #FFF;
            padding-bottom: 45px;
            border-radius: 10px;
            box-shadow: 0 0 20px 0 rgba(29, 33, 41, 0.05);
            width: 90%;
            height: 300px;

            .click{
                margin-left: 10px;
                margin-right: 10px;
                margin-top: 8px;
                height: 50px;
                border-radius: 25px;

                .css-26l3qy-menu{
                    width: 270px;
                    background-color: #f3f3f5;
                    border-color: rgba(255, 255, 255, 0);
                    border-style: solid;
                    border-width: 1px;
                    box-shadow: 0 0 20px 0 rgba(29,33,41,0.05);
                    position: absolute;
                    padding-top: 0px;
                    margin-top: -15px;
                    margin-left: -25px;
                    z-index: 3;
                    border-bottom-right-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                
                .sc-TOsTZ {
                    margin: 0px;
                    padding: 0px;
                    margin-top: -15px;
                    margin-left: 10px;
                    z-index: 3;
                }
            }
        }

        .info{
            z-index: -1;
            
            .text{
                width: 338px;
                height: 68px;
                margin: auto;
                font-family: Lato;
                font-size: 18px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #bac1cf;
                margin-bottom: 50px;
                left: 50%;
            }

            .image-search{
            }
        }
    }

}

@media only screen and (max-width: 360px) {
    div {
        form {
            display: flex;
            flex-direction: column;
            margin: auto;
            margin-top: -100px;
            background-color: #FFF;
            padding-bottom: 45px;
            border-radius: 10px;
            box-shadow: 0 0 20px 0 rgba(29, 33, 41, 0.05);
            width: 90%;
            height: 300px;

            .click{
                margin-left: 10px;
                margin-right: 10px;
                margin-top: 8px;
                height: 50px;
                border-radius: 25px;

                .css-26l3qy-menu{
                    width: 270px;
                    background-color: #f3f3f5;
                    border-color: rgba(255, 255, 255, 0);
                    border-style: solid;
                    border-width: 1px;
                    box-shadow: 0 0 20px 0 rgba(29,33,41,0.05);
                    position: absolute;
                    padding-top: 0px;
                    margin-top: -15px;
                    margin-left: -32px;
                    z-index: 3;
                    border-bottom-right-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                
                .sc-TOsTZ {
                    margin: 0px;
                    padding: 0px;
                    margin-top: -15px;
                    margin-left: 10px;
                    z-index: 3;
                }
            }
        }

        .info{
            z-index: -1;
            
            .text{
                width: 338px;
                height: 68px;
                margin: auto;
                font-family: Lato;
                font-size: 18px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #bac1cf;
                margin-bottom: 50px;
                left: 50%;
            }

            .image-search{
            }
        }
    }

}

@media only screen and (max-width: 350px) {
    div {
        form {
            display: flex;
            flex-direction: column;
            margin: auto;
            margin-top: -100px;
            background-color: #FFF;
            padding-bottom: 45px;
            border-radius: 10px;
            box-shadow: 0 0 20px 0 rgba(29, 33, 41, 0.05);
            width: 90%;
            height: 300px;

            .click{
                margin-left: 10px;
                margin-right: 10px;
                margin-top: 8px;
                height: 50px;
                border-radius: 25px;

                .css-27im3b-control{
                    width: 242px;
                }
                .css-qi07vp-control {
                    width: 242px;
                }

                .css-26l3qy-menu{
                    width: 270px;
                    background-color: #f3f3f5;
                    border-color: rgba(255, 255, 255, 0);
                    border-style: solid;
                    border-width: 1px;
                    box-shadow: 0 0 20px 0 rgba(29,33,41,0.05);
                    position: absolute;
                    padding-top: 0px;
                    margin-top: -15px;
                    margin-left: 30px;
                    z-index: 3;
                    border-bottom-right-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                
                .sc-TOsTZ {
                    margin: 0px;
                    padding: 0px;
                    margin-top: -15px;
                    margin-left: 10px;
                    z-index: 3;
                }
            }
        }

        .info{
            z-index: -1;
            
            .text{
                width: 338px;
                height: 68px;
                margin: auto;
                font-family: Lato;
                font-size: 16px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #bac1cf;
                margin-bottom: 50px;
                left: 20%;
            }

            .image-search{
            }
        }
    }
}

@media only screen and (max-width: 320px) {
    div {
        form {
            display: flex;
            flex-direction: column;
            margin: auto;
            margin-top: -100px;
            background-color: #FFF;
            padding-bottom: 45px;
            border-radius: 10px;
            box-shadow: 0 0 20px 0 rgba(29, 33, 41, 0.05);
            width: 90%;
            height: 300px;



            .click{
                margin-left: 10px;
                margin-right: 10px;
                margin-top: 8px;
                height: 50px;
                border-radius: 25px;

        
                .css-27im3b-control{
                    width: 242px;
                }
                .css-qi07vp-control {
                    width: 242px;
                }

                .css-1g36vmg-control {
                    width: 242px;
                }

                .css-26l3qy-menu{
                    width: 242px;
                    background-color: #f3f3f5;
                    border-color: rgba(255, 255, 255, 0);
                    border-style: solid;
                    border-width: 1px;
                    box-shadow: 0 0 20px 0 rgba(29,33,41,0.05);
                    position: absolute;
                    padding-top: 0px;
                    margin-top: -15px;
                    margin-left: -35px;
                    z-index: 3;
                    border-bottom-right-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                
                .sc-TOsTZ {
                    margin: 0px;
                    padding: 0px;
                    margin-top: -15px;
                    margin-left: 10px;
                    z-index: 3;
                }
            }
        }

        .info{

            
            z-index: -1;
            
            .text{
                width: 338px;
                height: 68px;
                margin: auto;
                font-family: Lato;
                font-size: 14px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                text-align: center;
                color: #bac1cf;
                margin-bottom: 50px;
                left: 4%;
                margin-left: -23px;
            }

            .image-search{
            }
        }
    }
}



`;